import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AiDescriptionForProjectResponse, ProjectDescriptionPayload } from '@edtech-ui/core/models/resume-builder/ai-description-projects';
import { AIGeneratedSummaryResponse, AISummaryPayload } from '@edtech-ui/core/models/resume-builder/ai-generated-summary';
import { StudentCreateResumeResponse } from '@edtech-ui/core/models/resume-builder/create-user-resume';
import { DeleteStudentResumeResponse } from '@edtech-ui/core/models/resume-builder/delete-user-resume';
import { GetResumeByIdApiResponse } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';
import { StudentResumeResponse } from '@edtech-ui/core/models/resume-builder/get-user-resume';
import { AnalysisStudentScoreResponse, AnalyzeScorePayload } from '@edtech-ui/core/models/resume-builder/resume-score-analyze';
import { SkillSuggestionResponse } from '@edtech-ui/core/models/resume-builder/soft-skills-user-resume';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ResumeService {

	resumeApiUrl = environment.resumeApiUrl;
	targetRole = new BehaviorSubject<string>('');
	private setupData: any = null;

	private resumeId: string = '';
	private fullResumeData$ = new BehaviorSubject<any>(null);

	private formData: any = {
		personal_info: null,
		education: [],
		skills: null,
		projects: [],
		experience: [],
		extras: null,
		summary: null
	};

	constructor(
		private http: HttpClient
	) { }

	setResumeId(id: string) {
		this.resumeId = id;
	}

	getResumeId() {
		return this.resumeId;
	}

	setSectionData(section: string, data: any) {
		this.formData[section] = data;
	}

	getSectionData(section: string) {
		return this.formData[section];
	}

	getAllData() {
		return this.formData;
	}

	setFullResumeData(data: any) {
		this.fullResumeData$.next(data);
	}

	getFullResumeData() {
		return this.fullResumeData$.asObservable();
	}


	resetResumeBuilder() {
		this.resumeId = '';
		this.targetRole.next('');
		this.fullResumeData$.next(null);
		this.setupData  = null;
		this.formData = {
			personal_info: null,
			education: [],
			skills: null,
			projects: [],
			experience: [],
			extras: null,
			summary: null
		};
	}


		setSetupData(data: any) {
		this.setupData = data;
		}


		getSetupData() {
		return this.setupData;
		}


	getStudentsResume(pageNo: number, pageSize: number): Observable<StudentResumeResponse> {
		const params = new HttpParams().set('page', pageNo).set('page_size', pageSize);
		return this.http.get<StudentResumeResponse>(`${this.resumeApiUrl}/user/resumes`, { params });
	}

	deleteStudentResume(resumeId: string): Observable<DeleteStudentResumeResponse> {
		return this.http.delete<DeleteStudentResumeResponse>(`${this.resumeApiUrl}/${resumeId}`);
	}

	postStudentResume(payload: FormData): Observable<StudentCreateResumeResponse> {
		return this.http.post<StudentCreateResumeResponse>(`${this.resumeApiUrl}/`, payload);
	}


	updateStudentResume(resumeId: string, payload: any): Observable<any> {

		const formData = new FormData();
		formData.append('section_data', JSON.stringify(payload));
		if (payload.file) {
			formData.append('file', payload.file);
		}
		return this.http.patch<any>(`${this.resumeApiUrl}/${resumeId}`, formData);
	}

	getStudentSoftSkills(targetRole: string): Observable<SkillSuggestionResponse> {
		const params = new HttpParams().set('target_role', targetRole);
		return this.http.get<SkillSuggestionResponse>(`${this.resumeApiUrl}/metadata/skills`, { params });
	}


	postAiDescriptionForProject(payload: ProjectDescriptionPayload): Observable<AiDescriptionForProjectResponse> {
		return this.http.post<AiDescriptionForProjectResponse>(`${this.resumeApiUrl}/ai/polish-description`, payload);
	}

	postAIGeneratedSummary(payload: AISummaryPayload): Observable<AIGeneratedSummaryResponse> {
		return this.http.post<AIGeneratedSummaryResponse>(`${this.resumeApiUrl}/ai/suggest-summaries`, payload);
	}

	getStudentResumeById(resumeId: string): Observable<GetResumeByIdApiResponse> {
		return this.http.get<GetResumeByIdApiResponse>(`${this.resumeApiUrl}/${resumeId}`);
	}

	postAnalysisStudentScore(resumeId: string): Observable<AnalysisStudentScoreResponse> {
		return this.http.post<AnalysisStudentScoreResponse>(`${this.resumeApiUrl}/ai/analyze-ats/${resumeId}`, {});
	}

}